import React from 'react';

class Feedback extends React.Component {
    render() {
        return (
            <div className="feedback"><h2 className="feedback__title" id="feedback">О нас говорят</h2>
                <div className="feedback__list">
                    <div className="feedback__item">
                        <div className="feedback__text">Хочу сказать большое спасибо команде <b>SURVEY</b> STUDIO за быструю,
                            качественную работу и отзывчивый клиентский сервис. Мы провели уже несколько совместных
                            проектов, и надеемся на продолжение нашего сотрудничества.
                        </div>
                        <div className="feedback__credits"><img className="feedback__author-img"
                                                                src="/images/AndreyE.png" alt=""
                                                                role="presentation"/>
                            <div className="feedback__author-info">
                                <div className="feedback__author-job">Директор по исследованиям <a href="http://human-nature.ru/" target="_blank">Human Nature</a>
                                </div>
                                <div className="feedback__author-name">Андрей Ермолаев</div>
                            </div>
                        </div>
                    </div>
                    <div className="feedback__item">
                        <div className="feedback__text">Сотрудничаем с командой <b>SURVEY</b> STUDIO уже более 5-лет.
                            Постоянно используем сервис для проведения опросов и программу автодозвона DEX, что значительно улучшило производительность нашего колл центра.
                            За все время работы у нас сложилось только самое лучшее впечатление о ребятах.
                            Команда профессионалов всегда быстро реагирует на наши запросы и вопросы, учитывает все пожелания, консультирует.
                            Часто пользуемся услугой программирования анкет.
                            Для них нет нерешаемых задач и мы всегда остаемся довольны.
                        </div>
                        <div className="feedback__credits"><img className="feedback__author-img"
                                                                src="/images/JuliaB.png" alt=""
                                                                role="presentation"/>
                            <div className="feedback__author-info">
                                <div className="feedback__author-job">Руководитель колл-центра, компания <a href="http://www.caticallcenter.com/" target="_blank">CATI Call center</a>
                                </div>
                                <div className="feedback__author-name">Юлия Бойко</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default Feedback;


// WEBPACK FOOTER //
// ./src/Components/MainPage/Feedback.js